import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Header.css";


const Header = ({ hasHiddenAuthButtons, children }) => {
   
    
    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
       
        {
          children !== null ? children : null
        }
        {hasHiddenAuthButtons ? <Link to="/">
          <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
        >
          Back to explore
        </Button>
          </Link> :
        localStorage.getItem("username") === null ? 
        <Stack direction="row" spacing={2}>
          {/* <Link to="/">
          <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
        >
          Back to explore
        </Button>
          </Link> */}
          <Link to="/register" underline="none">
            <Button variant="contained">Register</Button>
          </Link>
          <Link to="/login" underline="none">
            <Button variant="outlined">Login</Button>
          </Link>
        </Stack>:
        <Stack direction="row" spacing={2}>
            
          <Stack direction="row" spacing={0}>
            <Avatar src="avatar.png" alt={localStorage.getItem("username")} />
            <Button variant="text">
              {localStorage.getItem("username")}
            </Button>
          </Stack>
          <Link to="/login">
          <Button variant="contained" onClick={(e) => {
            localStorage.clear();
          }}>
            Logout
          </Button>
          </Link>
        </Stack>
        }
      </Box>
    );
};

export default Header;
